import React from 'react';
import { useEmpresaSelecionada } from '../../contexts/EmpresaContext';
import EmptyState from './EmptyState';

export default function AvisoSelecioneEmpresa({ semEmpresaCadastrada }) {
  const { modoGlobal } = useEmpresaSelecionada();

  if (semEmpresaCadastrada) {
    return (
      <EmptyState
        icon="bi-building"
        titulo="Nenhuma empresa cadastrada"
        texto="Cadastre a primeira empresa da plataforma para começar."
        acaoLabel="Cadastrar empresa"
        acaoTo="/empresas/novo"
      />
    );
  }

  if (modoGlobal) {
    return (
      <EmptyState
        icon="bi-globe2"
        titulo="Sem visão Global aqui"
        texto="Essa tela ainda não tem uma visão de todas as empresas — troque para uma empresa específica no seletor do topo da página."
      />
    );
  }

  return <EmptyState icon="bi-building" titulo="Selecione uma empresa" texto="Escolha uma empresa no seletor do topo da página para continuar." />;
}
